import React, { useContext } from 'react';

import { I18NContext } from './I18NContext';

export const I18N = ({ children, as, tag, forwardedRef, i18n: i18nProp, ...customProps }) => {
  as = as || tag;
  const i18n = useContext(I18NContext);
  const key = typeof children === 'string' ? children : ''
  let message = ''

  if (i18nProp) {
    message = i18n.get(key, i18nProp)
  } else {
    const [_key, ...placeholder] = key.split(/\s*,\s*/)
    message = i18n.get(_key, placeholder)
    message = message === _key ? key : message
  }

  const dangerouslyHTML = /(<[^>]+\/?>)|(&\w{2,4};)/.test(message) ? message : undefined;

  if (!as && !dangerouslyHTML && Object.keys(customProps).length === 0) {
    return message || children;
  }

  const Tag = as || 'span';
  const outputProps = Object.assign(
    {},
    ...Object.keys(customProps).map((propName) => {
      if (!/^i18n-/i.test(propName)) {
          return { [propName]: customProps[propName] }
      }

      const _propName = propName.replace(/^i18n-/i, '')

      if (typeof customProps[propName] !== 'string') {
          return { [_propName]: message }
      }

      const [_key, ...placeholder] = customProps[propName].split(/\s*,\s*/)
      let _message = i18n.get(_key, placeholder)
      _message = _message === _key ? customProps[propName] : _message

      return { [_propName]: _message }
    }),
    dangerouslyHTML ? { dangerouslySetInnerHTML: { __html: dangerouslyHTML } } : { children: message || children }
  );

  return <Tag ref={forwardedRef} {...outputProps} />;
};
